<!-- version 2021/05/20 -->
<template>
    <span v-html="text"></span>
</template>

<script>
    export default {
        props: {
            text: String
        }
    }
</script>

<style lang="sass" scoped>
    span
        font-weight: 300
        color: #405E66
        font-size: 16px
</style>
